import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { Box, Column, Copy, H4, Media, Optional, Row } from '@honda-canada/design-system-react';
import { useTranslation } from 'react-i18next';

import ModelDetails from './ModelDetails';
import PriceAndFinanceDetails from '../PriceAndFinanceDetails';
import themeStyles from './styles/ProductDetails.styles';

const ProductDetailsWrapper = themeStyles.apply(Box, 'ProductDetailsWrapper');
const ModelHeading = themeStyles.apply(H4, 'ModelHeading');
const ModelSubHeading = themeStyles.apply(Copy, 'ModelSubHeading');
const ModelDetailsColumn = themeStyles.apply(Column, 'ModelDetailsColumn');

const ProductDetails = ({
  modelYear,
  modelName,
  layout,
  isFetching,
  hasError,
  selectedExteriorColor,
  setSelectedExteriorColor,
}) => {
  const { t } = useTranslation();

  useEffect(() => {
    if (typeof window !== 'undefined') window.scrollTo(0, 0);
  }, []);

  return (
    <ProductDetailsWrapper>
      <Row>
        <Media greaterThan="mobile">
          <Column width="100%">
            <ModelHeading data-testid="cy-price-and-finance-heading">{`${modelYear} ${modelName}`}</ModelHeading>
          </Column>
        </Media>
        <Column width="100%">
          <ModelSubHeading size="regular" data-testid="cy-price-and-finance-sub-heading">
            {t('Sub-apps.PriceAndFinance.chooseYourFinanceText')}
          </ModelSubHeading>
        </Column>
      </Row>
      <Row>
        <ModelDetailsColumn width={[1, 1 / 2, 3 / 5]}>
          <Optional when={!isFetching && !hasError}>
            <ModelDetails
              layout={layout}
              selectedExteriorColor={selectedExteriorColor}
              setSelectedExteriorColor={setSelectedExteriorColor}
            />
          </Optional>
        </ModelDetailsColumn>
        <Column width={[1, 1 / 2, 2 / 5]}>
          <PriceAndFinanceDetails />
        </Column>
      </Row>
    </ProductDetailsWrapper>
  );
};

ProductDetails.propTypes = {
  modelName: PropTypes.string,
  modelYear: PropTypes.string,
  layout: PropTypes.shape({}),
  isFetching: PropTypes.bool,
  hasError: PropTypes.bool,
  selectedExteriorColor: PropTypes.string,
  setSelectedExteriorColor: PropTypes.func,
};

export default ProductDetails;
